import Cookies from 'js-cookie';
import React, { createContext, useEffect, useState} from 'react';
import { useMyCollege, usePersistentState } from '../utils';

export const NecttosContext = createContext();

function NecttosContextProvider({ children }) {
	const [collegeList, setCollegeList] = useState([]);
	const [profile, setProfile] = useState({});
	const [icons, setIcons] = useState([]);
	const [selectedCollege, setSelectedCollege] = useState({});
	const [college, setCollege] = useState({});
	const [collegeId, setCollegeId] = usePersistentState('collegeId', '');
	const [dashboard, setDashboard] = usePersistentState('dashboard', 'primary');
	const [userId, setUserId] = useState('');
	const [role, setRole] = useState([]);

	const { data: collegeData, isLoading } = useMyCollege(collegeId);

	useEffect(() => {
		if (!isLoading && collegeData) {
			setCollege(collegeData);
		}
	}, [collegeData, isLoading]);

	return (
		<NecttosContext.Provider
			value={{
				collegeList,
				profile,
				icons,
				selectedCollege,
				collegeId,
				userId,
				role,
				dashboard,
				setDashboard,
				college,
				setCollege,
				setRole,
				setUserId,
				setCollegeList,
				setProfile,
				setIcons,
				setSelectedCollege,
				setCollegeId,
				isLoading,
			}}>
			{children}
		</NecttosContext.Provider>
	);
}

export default NecttosContextProvider;
